// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3fCfR","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3KQqj"};